var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadmapIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_867_374)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.75 4.3125H24.4375V0H21.5625V4.3125H17.25V0H14.375V4.3125H11.5C9.59531 4.3125 7.7625 5.07006 6.41844 6.41772C5.75028 7.08462 5.22032 7.87684 4.85894 8.74897C4.49756 9.62109 4.31186 10.556 4.3125 11.5V14.375H0V17.25H4.3125V21.5625H0V24.4375H4.3125V28.75H0V31.625H4.3125V34.5C4.31186 35.444 4.49756 36.3789 4.85894 37.251C5.22032 38.1232 5.75028 38.9154 6.41844 39.5823C7.08562 40.2498 7.87781 40.7793 8.74973 41.1405C9.62166 41.5018 10.5562 41.6876 11.5 41.6875H14.375V46H17.25V41.6875H21.5625V46H24.4375V41.6875H28.75V46H31.625V41.6875H34.5C36.4047 41.6875 38.2375 40.9299 39.5816 39.5823C40.2497 38.9154 40.7797 38.1232 41.1411 37.251C41.5024 36.3789 41.6881 35.444 41.6875 34.5V31.625H46V28.75H41.6875V24.4375H46V21.5625H41.6875V17.25H46V14.375H41.6875V11.5C41.6881 10.556 41.5024 9.62109 41.1411 8.74897C40.7797 7.87684 40.2497 7.08462 39.5816 6.41772C38.9144 5.75019 38.1222 5.22068 37.2503 4.85946C36.3783 4.49823 35.4438 4.31237 34.5 4.3125H31.625V0H28.75V4.3125ZM28.75 14.375V31.625H31.625V14.375H28.75ZM14.375 19.4062V31.625H17.25V26.5938H21.5625V31.625H24.4375V19.4062C24.4375 16.6276 22.1878 14.375 19.4062 14.375C16.6247 14.375 14.375 16.6276 14.375 19.4062ZM21.5625 23.7188V19.4062C21.5625 18.2153 20.5994 17.25 19.4062 17.25C18.2131 17.25 17.25 18.2153 17.25 19.4062V23.7188H21.5625Z",
    fill: "url(#paint0_linear_867_374)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_867_374",
    x1: 46,
    y1: 23,
    x2: 0,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37A058"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_867_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapIcon2);
export default __webpack_public_path__ + "static/media/roadmap-icon-2.812c160b9eb17fdc155e087032ea6280.svg";
export { ForwardRef as ReactComponent };